import acAutomation from './ac-automation.vue'

export default acAutomation